import { useKeycloak } from "@react-keycloak/web";
import { Fragment, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { TUserRoles } from "../types";

interface Props {
  children: ReactNode;
  roles: TUserRoles[];
}

export default function AuthGuard({ children, roles }: Props) {
  const isAuth = useAuth(roles);
  const { keycloak } = useKeycloak();

  if (isAuth && keycloak.authenticated) {
    return <Fragment>{children}</Fragment>;
  }

  return <Navigate to="/sign-in" />;
}
